import { ENERGY_SOURCE_KEY } from "../bisko/energy-source-key";
import { MethodologyType } from "../methodology/types";
import { GHG_ADMINISTRATION_METHODOLOGY_ID } from "./constants";
export const GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP = {
    type: MethodologyType.GHG_ADMINISTRATION,
    id: GHG_ADMINISTRATION_METHODOLOGY_ID,
    sectors: {
        MUNICIPAL_FACILITIES: {
            id: "gtr5xvo3i32j4b8oq1yo7u8r",
            title: "Kommunale Einrichtungen",
            subsectors: {
                SCHOOLS_DAYCARE: { id: "adcj3di9d5c5hsjz8a8hys0y", title: "Schulen/ Kindertagesstätten" },
                ADMINISTRATIVE_BUILDINGS: { id: "rhe4djeyikj4zyhjxqjgooxn", title: "Verwaltungsgebäude" },
                STREET_LIGHTING: { id: "ps7hieivthws1kjhzb5ggy1x", title: "Straßenbeleuchtung" },
                MUNICIPAL_INFRASTRUCTURE: {
                    id: "vyx4hcew0g6phaf05f23ea3f",
                    title: "Kommunale Infrastrukturanlagen aus den Bereichen Wasser/Abwasser, Straßen, Abfall",
                },
                OTHER_MUNICIPAL_BUILDINGS: { id: "t28bvx16ahk888a7gr3bghsi", title: "Andere kommunale Gebäude" },
            },
            energySources: {
                NATURAL_GAS: { id: "gwxp4qa6tr6qid0o5rem6boy", title: "Erdgas", scope: 1, key: ENERGY_SOURCE_KEY.NATURAL_GAS },
                HEATING_OIL: { id: "my5kugikno4x13qayhrlmfka", title: "Heizöl", scope: 1, key: ENERGY_SOURCE_KEY.HEATING_OIL },
                LIQUID_GAS: {
                    id: "lhitxwsjdowahe6m1mssn3di",
                    title: "Flüssiggas",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.LPG_STATIONARY,
                },
                BIOGAS: { id: "rdadnpb59u5gypdot24a2shl", title: "Biogas", scope: 1, key: ENERGY_SOURCE_KEY.BIOGAS },
                BIOMASS: { id: "xs0em6yxz64gq6is5y79jbal", title: "Biomasse", scope: 1, key: ENERGY_SOURCE_KEY.BIOMASS },
                LIGNITE: { id: "lke4onp5sr9q6ypgw7pho1sx", title: "Braunkohle", scope: 1, key: ENERGY_SOURCE_KEY.LIGNITE },
                HARD_COAL: { id: "z2iulkreqj4qj5zkxo94fgyk", title: "Steinkohle", scope: 1, key: ENERGY_SOURCE_KEY.HARD_COAL },
                SOLAR_THERMAL: {
                    id: "kjfn4a6zynhvnxzqkf0zb79a",
                    title: "Solarthermie",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.SOLAR_THERMAL,
                },
                AMBIENT_HEAT: {
                    id: "hd4dokf7pi7fifb8uni1rfdt",
                    title: "Umweltwärme",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.ENVIRONMENTAL_HEAT,
                },
                OTHER_CONVENTIONAL: {
                    id: "s0qnkk8dgw1iiwnfenc9jrv6",
                    title: "Sonstige Konventionelle",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.OTHER_CONVENTIONAL,
                },
                OTHER_RENEWABLE: {
                    id: "fktwpip6u4obl8mmdpd0az8a",
                    title: "Sonstige Erneuerbare",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.OTHER_RENEWABLES,
                },
                ELECTRICITY: { id: "zrugky7ttlvu5qk0uagv2oj9", title: "Strom", scope: 2, key: ENERGY_SOURCE_KEY.ELECTRICITY },
                HEATING_ELECTRICITY: {
                    id: "dcmwn0s5w67dhh3wx2bg9f43",
                    title: "Heizstrom",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING,
                },
                DISTRICT_HEATING: {
                    id: "lpv080f56jtik30m8f1m3voa",
                    title: "Fernwärme",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.DISTRICT_HEATING,
                },
                LOCAL_HEATING: {
                    id: "naivjp8a72zbdfg0dzka5kh8",
                    title: "Nahwärme",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.LOCAL_HEATING,
                },
                NATURAL_GAS_WELL_TO_TANK: { id: "geth2vfje1hyys27f1pcna78", title: "Erdgas (Vorkette)", scope: 3 },
                HEATING_OIL_WELL_TO_TANK: { id: "37e39a5nlqzrqx3q5ihdm9gt", title: "Heizöl (Vorkette)", scope: 3 },
                HARD_COAL_WELL_TO_TANK: { id: "rqnjlh4o1xtvydyse4dwtyee", title: "Steinkohle (Vorkette)", scope: 3 },
                LIGNITE_WELL_TO_TANK: { id: "5ywnkzi8hqb0rcg2urjt4y7v", title: "Braunkohle (Vorkette)", scope: 3 },
                BIOGAS_WELL_TO_TANK: { id: "h25wo7wrygsfr337k0is37g0", title: "Biogas (Vorkette)", scope: 3 },
                BIOMASS_WELL_TO_TANK: { id: "e3d7dbzg9b8nxw4zs7z16d4r", title: "Biomasse (Vorkette)", scope: 3 },
                ELECTRICITY_WELL_TO_TANK: { id: "qgzipc3cjphgmwbk0ecb4tyv", title: "Strom (Vorkette)", scope: 3 },
                HEATING_ELECTRICITY_WELL_TO_TANK: { id: "dan7rmdooxvoju3kclhqlztc", title: "Heizstrom (Vorkette)", scope: 3 },
            },
        },
        VEHICLE_FLEET: {
            id: "km2opo4666p6x5sphn9gw4zr",
            title: "Fuhrpark",
            subsectors: {
                PASSENGER_CARS: { id: "rdsqpsebpqr51b7vsjbhbl9x", title: "Personenkraftwagen" },
                LIGHT_COMMERCIAL_VEHICLES: { id: "uzfv3nanhs1uek1dewy01j90", title: "Leichte Nutzfahrzeuge" },
                HEAVY_COMMERCIAL_VEHICLES: { id: "jbknn9c5cqwn3kw9yycgodwg", title: "Schwere Nutzfahrzeuge" },
            },
            energySources: {
                DIESEL: { id: "l1cerli2zdzgvdqrsiy8hdv8", title: "Diesel", scope: 1, key: ENERGY_SOURCE_KEY.DIESEL_FOSSIL },
                DIESEL_BIOGENIC: {
                    id: "vao8o87ktc5upodv91znfnr3",
                    title: "Diesel biogen",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.DIESEL_BIOGENIC,
                },
                GASOLINE: { id: "hd4dokf7pi7fifb8uni1rfdg", title: "Benzin", scope: 1, key: ENERGY_SOURCE_KEY.GASOLINE_FOSSIL },
                BIO_GASOLINE: {
                    id: "pvvkz4e0x3k0eiqzuy8atwdd",
                    title: "Biobenzin",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.GASOLINE_BIOGENIC,
                },
                NATURAL_GAS_CNG_LNG: {
                    id: "l35s1ykikz9khecrguj8cx41",
                    title: "Erdgas (CNG + LNG)",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.NATURAL_GAS_CNG_LNG,
                },
                BIO_CNG: { id: "c455t6hztfxrse1rjo9m9e6i", title: "Bio-CNG", scope: 1, key: ENERGY_SOURCE_KEY.BIOGAS_TRANSPORT },
                LPG: { id: "l35s1ykikz9khecrguj8cx40", title: "LPG", scope: 1, key: ENERGY_SOURCE_KEY.LPG_TRANSPORT },
                ELECTRICITY: { id: "zrugky7ttlvu5qk0uagv2oj9", title: "Strom", scope: 2, key: ENERGY_SOURCE_KEY.ELECTRICITY },
                DIESEL_WELL_TO_TANK: { id: "5b4l24empws5zu29z6hwte8t", title: "Diesel (Vorkette)", scope: 3 },
                DIESEL_BIOGENIC_WELL_TO_TANK: { id: "lx8wdupm2sjntw2m9cqeda4s", title: "Diesel biogen (Vorkette)", scope: 3 },
                GASOLINE_WELL_TO_TANK: { id: "sagullmdl9wffdbd9y5afc16", title: "Benzin (Vorkette)", scope: 3 },
                BIO_GASOLINE_WELL_TO_TANK: { id: "azsnqsus374xkzshaim7duac", title: "Biobenzin (Vorkette)", scope: 3 },
                NATURAL_GAS_CNG_LNG_WELL_TO_TANK: { id: "lxpf2gl7xs6m3lx6hmxwc4y1", title: "Erdgas (CNG + LNG) (Vorkette)", scope: 3 },
                LPG_WELL_TO_TANK: { id: "0mp9smcw9dgpejo3dmsbjxdr", title: "LPG (Vorkette)", scope: 3 },
                ELECTRICITY_WELL_TO_TANK: { id: "qgzipc3cjphgmwbk0ecb4tyv", title: "Strom (Vorkette)", scope: 3 },
            },
        },
        COMMUTING: {
            id: "awsec1k3p9qz2x1m4n6b8v0a",
            title: "Arbeitswege",
            subsectors: {
                COMMUTING_TRANSIT_BUS: { id: "awlbus5h2j8k4m1n7p3q9r0c", title: "Linienbus" },
                COMMUTING_PASSENGER_CAR: { id: "awpkw094d2f6g8h1j3k5l7m0", title: "Personenkraftwagen" },
                COMMUTING_LONG_DISTANCE_RAIL: { id: "awspfv2c4v6b8n1m3k5j7h0d", title: "Schienenpersonenfernverkehr" },
                COMMUTING_LOCAL_RAIL: { id: "awspnv9z7x5c3v1b8n6m4k0e", title: "Schienenpersonennahverkehr" },
                COMMUTING_TRAM_METRO: { id: "awssu037t5r9e1w3q7y2u4i0", title: "Stadt-, Straßen- und U-Bahn" },
            },
            energySources: {
                GASOLINE: { id: "awesbz4k2j8h6g1f3d0a2s4e", title: "Benzin", scope: 3 },
                BIO_GASOLINE: { id: "awesbb7m3n9b5v1c2x4z6q8w", title: "Biobenzin", scope: 3 },
                DIESEL: { id: "awesdi5l3k1j9h7g5f3d1s9a", title: "Diesel", scope: 3 },
                DIESEL_BIOGENIC: { id: "awesdb2n4m6b8v0c1x3z5q7w", title: "Diesel biogen", scope: 3 },
                NATURAL_GAS_CNG_LNG: { id: "awescn6t8r0e2w4q6y8u0i2o", title: "Erdgas (CNG + LNG)", scope: 3 },
                BIO_CNG: { id: "awesbc1p3o5i7u9y1t3r5e7w", title: "Bio-CNG", scope: 3 },
                LPG: { id: "aweslp8a6s4d2f0g8h1j3k5l", title: "LPG", scope: 3 },
                ELECTRICITY: { id: "awesst4h6g8f0d2s4a6e8w0q", title: "Strom", scope: 3 },
            },
        },
        BUSINESS_TRAVEL: {
            id: "drsec7p2q9z4x1m5n8b3v6k0",
            title: "Dienstreisen",
            subsectors: {
                BUSINESS_TRAVEL_PASSENGER_CAR: { id: "drpkw3f7g1h9j5k2l8m4n6p0", title: "Personenkraftwagen" },
                BUSINESS_TRAVEL_TRANSIT_BUS: { id: "drlbus2h8k4m1n7p3q9r5s0c", title: "Linienbus" },
                BUSINESS_TRAVEL_COACH: { id: "drrbus5j3k1h9g7f2d4s6a8w", title: "Reisebusse" },
                BUSINESS_TRAVEL_LONG_DISTANCE_RAIL: { id: "drspfv9c2v6b8n1m3k5j7h4d", title: "Schienenpersonenfernverkehr" },
                BUSINESS_TRAVEL_LOCAL_RAIL: { id: "drspnv4z7x5c3v1b8n6m2k0e", title: "Schienenpersonennahverkehr" },
                BUSINESS_TRAVEL_TRAM_METRO: { id: "drssu183t5r9e7w3q2y4u6i0", title: "Stadt-, Straßen- und U-Bahn" },
                BUSINESS_TRAVEL_AIR: { id: "drflug6m2n8b4v0c1x3z5q7w", title: "Flugverkehr" },
            },
            energySources: {
                GASOLINE: { id: "dresbz8k2j4h6g1f3d0a5s7e", title: "Benzin", scope: 3 },
                BIO_GASOLINE: { id: "dresbb3m7n9b5v1c2x4z6q8w", title: "Biobenzin", scope: 3 },
                DIESEL: { id: "dresdi6l3k1j9h7g5f2d4s8a", title: "Diesel", scope: 3 },
                DIESEL_BIOGENIC: { id: "dresdb1n4m6b8v0c3x5z7q9w", title: "Diesel biogen", scope: 3 },
                NATURAL_GAS_CNG_LNG: { id: "drescn5t8r0e2w4q6y1u3i9o", title: "Erdgas (CNG + LNG)", scope: 3 },
                BIO_CNG: { id: "dresbc2p3o5i7u9y1t4r6e8w", title: "Bio-CNG", scope: 3 },
                LPG: { id: "dreslp9a6s4d2f0g8h3j5k7l", title: "LPG", scope: 3 },
                KEROSENE: { id: "dreske4z1x3c5v7b9n2m6k8j", title: "Kerosin", scope: 3 },
                ELECTRICITY: { id: "dresst7h6g8f0d2s4a1e9w3q", title: "Strom", scope: 3 },
            },
        },
        WATER_CONSUMPTION: {
            id: "pc6im8bpta01suvwoz0npg0a",
            title: "Wasserverbrauch",
            unit: "m³",
            subsectors: {
                WATER_CONSUMPTION: { id: "ezw1qv8igicdxhp3hruz367x", title: "Wasserverbrauch" },
            },
            energySources: {
                WATER: { id: "fkyh33c8fqrywl0k1nf5212u", title: "Wasser", scope: 3 },
            },
        },
        PROCUREMENT: {
            id: "ohm9nqsyjmhgazur6z5yqf6j",
            title: "Beschaffung",
            unit: "t",
            subsectors: {
                PAPER_CONSUMPTION: { id: "okrwseh0oaqaam1lwym4n1wl", title: "Papierverbrauch" },
            },
            energySources: {
                PAPER_VIRGIN_STANDARD: { id: "a1m6yojd9fd6j58yvurc5mgh", title: "Frischfaser Normalpapier", scope: 3 },
                PAPER_RECYCLED_STANDARD: { id: "zri75aeij63e36rsqwxd4ufa", title: "Recycling Normalpapier", scope: 3 },
                PAPER_VIRGIN_HYGIENE: { id: "cxkftbr2lws3chu824kjbmlq", title: "Frischfaser Hygienepapier", scope: 3 },
                PAPER_RECYCLED_HYGIENE: { id: "rv3fy9rpjwee2hcv6cowbouq", title: "Recycling Hygienepapier", scope: 3 },
            },
        },
    },
};
